import { render, staticRenderFns } from "./billing-setup-form.vue?vue&type=template&id=3d3f21e7&"
import script from "./billing-setup-form.vue?vue&type=script&lang=ts&"
export * from "./billing-setup-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports